<template>
  <div class="application">
   <div class="nav-title">全部应用</div>
   <div class="list-box">
     <div class="title-box">涉旅企业管理</div>
     <div class="con-box">
       <div class="items-box">
         <img  class="items-img" src="../../assets/index/ic_chengxin.png" alt="" />
         <p class="items-text">诚信</p>
       </div>
        <div class="items-box">
         <img  class="items-img" src="../../assets/index/ic_daoyou.png" alt="" />
         <p class="items-text">导游</p>
       </div>
        <div class="items-box">
         <img  class="items-img" src="../../assets/index/ic_lvxingshe.png" alt="" />
         <p class="items-text">旅行社</p>
       </div>
     </div>
   </div>
   <div class="list-box">
     <div class="title-box">分类名</div>
     <div class="con-box">
       <div class="items-box">
         <img  class="items-img" src="../../assets/index/ic_toushu.png" alt="" />
         <p class="items-text">投诉</p>
       </div>
        <div class="items-box">
         <img  class="items-img" src="../../assets/index/ic_tuihuo.png" alt="" />
         <p class="items-text">退货</p>
       </div>
     </div>
   </div>
   <div class="list-box">
     <div class="title-box">分类名</div>
     <div class="con-box">
       <div class="items-box">
         <img  class="items-img" src="../../assets/index/ic_kaohe.png" alt="" />
         <p class="items-text">考核平台</p>
       </div>
     </div>
   </div>
  </div>
</template>

<script>

    export default {
        components: {

        },
        data () {
            return {}
        },
        computed: {

        },
        watch: {

        },
        methods: {

        },
        mounted () {
        },

        created () {
        }

    }
</script>

<style scoped lang="less">
.application{
  box-sizing: border-box;
  padding: 0 12px;
  background:rgba(251,251,251,1);
  width: 100%;
  height: 100%;

  .nav-title{
    font-size:20px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:68px;
  }
  .list-box{
    width:100%;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    margin-bottom: 24px;

    .title-box{
      font-size:14px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(51,51,51,1);
      line-height:46px;
      box-sizing: border-box;
      padding-left: 16px;
      border-bottom: 1px solid #EEEEEE;

    }
    .con-box{
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .items-box{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 88px;
        height: 113px;

        .items-img{
          width: 40px;
          height: 40px;
          margin-bottom: 14px;
        }
        .items-text{
          font-size:12px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(51,51,51,1);
          line-height:12px;
        }
      }
    }
  }
}

</style>
